import { TaskIcon, ICON_TYPES } from './TaskIcon';

export default TaskIcon;
export { TaskIcon, ICON_TYPES };
